import React, { useEffect, useMemo, useState } from "react";
import { affiliationGroups } from "keys";
import { Outlet } from "react-router-dom";
import { secretStorage } from "config";
import { affiliationGroupNames } from "keys/affiliationGroups"
import { isEmpty } from "lodash";
import { useSelector } from "react-redux";

export const SystemReviewContext = React.createContext();

const SystemReviewPage = () => {
    //  ניהול הנתונים המשובתפים לארבעת המסכים
    const [draftAssessmentFilters, setDraftAssessmentFilters] = useState({})
    const [appliedAssessmentFilters, setAppliedAssessmentFilters] = useState({})

    const { roleIndex } = useSelector(state => state.user)

    const storage = secretStorage.getItem("user")
    const { user_data } = storage || {}
    const { affiliation_groups } = user_data?.[roleIndex]?.user_data || {}
    const filterAffiliationGroups = affiliation_groups?.filter(group => affiliationGroupNames.includes(group.name))

    useEffect(() => {
        // מכניס את הערכים הדיפולטיבים של הפילטרים

        if (filterAffiliationGroups?.length && isEmpty(draftAssessmentFilters)) {
            const defaultFilters = {
                group: filterAffiliationGroups?.[0],
            }
            setDraftAssessmentFilters(defaultFilters)
            setAppliedAssessmentFilters(defaultFilters)
        }
    }, [filterAffiliationGroups])

    const commonState = useMemo(() => ({
        draftAssessmentFilters, setDraftAssessmentFilters,
        appliedAssessmentFilters, setAppliedAssessmentFilters,
        isSchoolGroup: draftAssessmentFilters.group?.name == affiliationGroups.schools
    }), [draftAssessmentFilters, appliedAssessmentFilters])

    return (
        <SystemReviewContext.Provider value={commonState}>
            <Outlet />
        </SystemReviewContext.Provider>
    );
};

export default SystemReviewPage;